// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner_2X4DF881ZAuWr3ur65bX2Q","spin":"styles_spin_23Q_VFTziEKihfLwuMB9kk"};